import React, { useEffect, useState } from "react";
import "./styles/BhpBizCard.css";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  bhpEditLinks,
  getFileThumbnailDB,
  getPageType,
  whatsappMessage,
} from "../types/constants";
import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonPopover,
  IonRow,
} from "@ionic/react";
import {
  add,
  call,
  callSharp,
  location,
  logoWhatsapp,
  navigate,
  pencil,
} from "ionicons/icons";
import {
  BhpMarketTypes,
  BhpThemeHeaderWithBack,
  SeoUrlDetailsType,
} from "../pages/BussinessHomePage";
import {
  callPhone,
  getSeoUrl,
  getValidWhatsAppPhone,
} from "../common/commonFunctions";
import { useRecordUserInteractions, userActionsTable } from "../app/hooks";
import { useHistory } from "react-router";
import { getSessionDetails } from "../common/cookies";
import { getBhpShareMessage } from "../types/bhp_common_function";
import BhpContactCard from "./BhpContactCard";

const BhpBizCard: React.FC<{
  id?: string | number;
  imgData?: string;
  name: string;
  catImg?: string;
  marketName?: string;
  marketType?: BhpMarketTypes;
  onClick?: () => void;
  phones?: string[];
  profession?: string;
  address?: string;
  isCollapsed?: boolean;
  paddingBottomPx?: number;
  disableCollapseExpand?: boolean;
  disableContactUs?: boolean;
  disableSave?: boolean;
  cardPadding?: number;
  isMarket?: boolean;
  noButtons?: boolean;
  buttonOverrideContactUs?: {
    name: string;
    exec: () => void;
  };
  buttonOverrideShare?: {
    name: string;
    exec: () => void;
  };
  buttonOverrideSave?: {
    name: string;
    exec: () => void;
  };
  whatsappInfo?: {
    marketDomain?: string;
    domainName: string;
    marketType?: BhpMarketTypes;
    isMarket: boolean;
    name: string;
    seoDetails: SeoUrlDetailsType;
  };
  namePrefix?: string;
  isPersonal?: boolean;
  recordUserInteraction?: boolean;
  shortDescription?: string;
  highlightButton?: {
    name: string;
    icon: any;
    onClick: () => void;
  };
  editMode?: boolean;
  bhpEditLinks?: any;
  subType?: string;
  vypzeePage?: boolean;
  save?: () => void;
}> = (props) => {
  const baseUrl = `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?percentage=40&Authorization=${API_SECURE_KEY}&`;
  const url = props.isPersonal
    ? "assets/profile.avif"
    : "assets/shop-logo.avif";
  const address = props.address
    ? props.address.split("\n").map((el, idx) => {
        return <div key={idx}>{el}</div>;
      })
    : [];

  const getPhone = () => {
    let retval = [];
    for (let i = 0; i < props.phones?.length; i++) {
      retval.push(props.phones[i]);
      if (i == 1) break;
    }
    return retval;
  };

  const phones = getPhone();
  const [openPhone, setOpenPhone] = useState(false);
  const propImg = !!props.imgData
    ? props.imgData
    : props?.catImg && props?.vypzeePage
    ? `${baseUrl}fileName=${props.catImg}`
    : url;
  const [cardExpanded, setCardExpanded] = useState(true);

  useEffect(() => {
    setCardExpanded(!props.isCollapsed);
  }, [props.isCollapsed]);

  const phonePopoverJsx = (
    <BhpContactCard
      dismiss={() => {
        setOpenPhone(false);
      }}
      open={openPhone}
      phones={props.phones}
      name={props.name}
      isMarket={props.isMarket}
      marketType={props.marketType}
      pageId={props.id}
      pageSection={"MAIN"}
      recordUserInteraction={true}
      save={props.save}
    />
  );

  //   const getAddress = () => {
  //     let retVal = "";
  //     if (!props.address) return "";
  //     const addressFrag = props.address.split(",");
  //     for (let i = 0; i < addressFrag?.length; i++) {
  //       retVal += `${i == 0 ? "" : ", "}${addressFrag[i]}`;
  //     }
  //     return retVal;
  //   };
  const recordAction = useRecordUserInteractions();
  const history = useHistory();

  const getCardSizeCss = (): string => {
    if (cardExpanded) {
      if (props.whatsappInfo) return "bhp-biz-card-card-expanded";
      else return "bhp-biz-card-card-expanded-wo-wa";
    } else {
      if (props.whatsappInfo) return "bhp-biz-card-card-collapsed";
      else return "bhp-biz-card-card-collapsed-wo-wa";
    }
  };

  const maxLength = 50;

  return (
    <>
      {phonePopoverJsx}
      <div
        className="bhp-biz-card-top"
        style={{
          padding: props.cardPadding ? `${props.cardPadding}px` : "10px",
          paddingBottom: props.paddingBottomPx
            ? `${props.paddingBottomPx}px`
            : 0,
        }}
      >
        <div className={`bhp-biz-card-card ${getCardSizeCss()}`}>
          {!props.disableCollapseExpand && (
            <div
              style={{
                position: "absolute",
                right: "8px",
                top: "5px",
                zIndex: 10000,
                background: "red",
                color: "white",
                borderRadius: "10px",
                fontSize: "0.7rem",
                padding: "3px 8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "bold",
              }}
              onClick={() => {
                setCardExpanded((val) => !val);
              }}
            >
              {cardExpanded ? "-" : "+"}
            </div>
          )}
          {/* <div className="bhp-biz-card-banner"> */}
          {!!propImg && (
            <img
              src={propImg}
              alt=""
              loading="lazy"
              className="bhp-biz-card-banner-img"
            />
          )}
          <div
            className={`bhp-biz-card-banner-shade ${
              cardExpanded
                ? "bhp-biz-card-banner-shade-expand"
                : "bhp-biz-card-banner-shade-collapse"
            }`}
          ></div>
          {/* </div> */}
          <div
            className={`bhp-biz-card-text ${
              cardExpanded
                ? "bhp-biz-card-text-expanded"
                : "bhp-biz-card-text-collapsed"
            }`}
            style={{
              justifyContent: cardExpanded ? "space-between" : "center",
            }}
          >
            <div className="bhp-biz-card-title-text">
              {!!props.namePrefix && (
                <div style={{ color: "lightgray", paddingBottom: "5px" }}>
                  {props.namePrefix}
                </div>
              )}
              <div style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                {props.name}
              </div>
              <div
                style={{
                  paddingTop: "5px",
                  fontSize: "0.7rem",
                  color: "var(--ion-color-light)",
                }}
              >
                {props.profession
                  ? props.profession
                  : address && !(props.isMarket && props.marketType === "USER")
                  ? address[0]
                  : props.marketName}
              </div>
            </div>
            {cardExpanded && (
              <div className="bhp-biz-card-text-container">
                {!!phones.length && (
                  <>
                    {/* <div className="bhp-biz-card-contact-text">Contact Us</div> */}
                    <div
                      style={{ paddingBottom: "5px" }}
                      onClick={() => {
                        setOpenPhone(true);
                      }}
                    >
                      <IonGrid class="bhp-biz-card-phone-grid">
                        <IonRow>
                          <IonCol size="2">
                            <div
                              style={{
                                height: "20px",
                                width: "20px",
                                background: "var(--ion-color-light)",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <IonIcon icon={call} color="dark" />
                            </div>
                          </IonCol>
                          <IonCol size="10">
                            <div
                              style={{
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                              }}
                            >
                              {phones?.map((el, idx) => {
                                return <div key={idx}>{el}</div>;
                              })}
                            </div>
                          </IonCol>
                        </IonRow>
                        {!!props.profession && !!address.length && (
                          <IonRow>
                            <IonCol size="2">
                              <IonIcon icon={location} />
                            </IonCol>
                            <IonCol size="10">
                              {props.isMarket && props.marketType === "USER"
                                ? props.marketName
                                : address[0]}
                            </IonCol>
                          </IonRow>
                        )}
                        {/* {!!address.length && (
                        <IonRow>
                          <IonCol size="2">
                            <IonIcon icon={location} />
                          </IonCol>
                          <IonCol size="10">{address[0]}</IonCol>
                        </IonRow>
                      )} */}
                      </IonGrid>
                    </div>
                  </>
                )}
                {!props.noButtons && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    {/* <div
                      className="bhp-biz-card-btn"
                      onClick={() => {
                        if (props.buttonOverrideContactUs) {
                          props.buttonOverrideContactUs.exec();
                          return;
                        }
                        setOpenPhone(true);
                      }}
                      style={{
                        background: "#ffde59",
                        color: "var(--ion-color-bhp-footer)",
                      }}
                    >
                      {props.buttonOverrideContactUs && (
                        <>{props.buttonOverrideContactUs.name}</>
                      )}
                      {!props.buttonOverrideContactUs && <>Contact</>}
                    </div> */}
                    <div style={{ width: "5px" }}></div>
                    <div
                      className={`bhp-biz-card-btn save-contact`}
                      onClick={() => {
                        if (props?.recordUserInteraction) {
                          recordAction({
                            notes: `Click ${
                              props.buttonOverrideSave
                                ? props.buttonOverrideSave.name
                                : "Save"
                            }`,
                            action: userActionsTable.save,
                            pageId: props.id,
                            pageSection: "MAIN",
                            pageType: getPageType(
                              props.isMarket,
                              props.marketType
                            ),
                          });
                        }
                        if (props.buttonOverrideSave) {
                          props.buttonOverrideSave.exec();
                          return;
                        }
                        props.onClick();
                      }}
                    >
                      {props.buttonOverrideSave && (
                        <>{props.buttonOverrideSave.name}</>
                      )}
                      {!props.buttonOverrideSave && <>Save</>}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {/* {!!props.imgData && ( */}
          {cardExpanded && (
            <div
              className={`bhp-biz-card-logo ${
                cardExpanded
                  ? "bhp-biz-card-text-expanded"
                  : "bhp-biz-card-text-collapsed"
              }`}
            >
              <div className="bhp-biz-card-logo-img-wrpr">
                <img src={propImg} alt="" className="bhp-biz-card-logo-img" />
              </div>
            </div>
          )}
          {!cardExpanded && !props.noButtons && (
            <div
              className={`bhp-biz-card-collapsed-buttons
            ${
              cardExpanded
                ? "bhp-biz-card-text-expanded"
                : "bhp-biz-card-text-collapsed"
            }
            `}
            >
              {/* <div
                className="bhp-biz-card-call-btn"
                onClick={() => {
                  setOpenPhone(true);
                }}
              >
                <IonIcon icon={call} />
              </div> */}
              {!props.disableContactUs && (
                <>
                  <div
                    className={`bhp-biz-card-btn ${
                      props.isCollapsed ? "bhp-biz-card-btn-large" : ""
                    }`}
                    onClick={() => {
                      if (props?.recordUserInteraction) {
                        recordAction({
                          notes: `Click ${
                            props.buttonOverrideContactUs
                              ? props.buttonOverrideContactUs.name
                              : "Contact"
                          }`,
                          action: userActionsTable.contact,
                          pageId: props.id,
                          pageSection: "MAIN",
                          pageType: getPageType(
                            props.isMarket,
                            props.marketType
                          ),
                        });
                      }
                      if (props.buttonOverrideContactUs?.exec) {
                        props.buttonOverrideContactUs.exec();
                        return;
                      }
                      setOpenPhone(true);
                    }}
                    style={{
                      background: "#ffde59",
                    }}
                  >
                    {props.buttonOverrideContactUs?.name
                      ? props.buttonOverrideContactUs.name
                      : "Contact"}
                  </div>
                  <div style={{ height: "5px" }}></div>
                </>
              )}
              {!props.disableSave && (
                <div
                  className={`bhp-biz-card-btn ${
                    props.isCollapsed ? "bhp-biz-card-btn-large" : ""
                  }`}
                  onClick={() => {
                    if (props?.recordUserInteraction) {
                      recordAction({
                        notes: `Click ${
                          props.buttonOverrideSave
                            ? props.buttonOverrideSave.name
                            : props.isMarket && props.marketType !== "USER"
                            ? props.isMarket && props?.marketType === "MARKET"
                              ? "Save Directory"
                              : "Save Contact"
                            : "Save"
                        }`,
                        action: userActionsTable.save,
                        pageId: props.id,
                        pageSection: "MAIN",
                        pageType: getPageType(props.isMarket, props.marketType),
                      });
                    }
                    if (props.buttonOverrideSave) {
                      props.buttonOverrideSave.exec();
                      return;
                    }
                    props.onClick();
                  }}
                >
                  {props.buttonOverrideSave
                    ? props.buttonOverrideSave.name
                    : props.isMarket && props.marketType !== "USER"
                    ? props.isMarket && props?.marketType === "MARKET"
                      ? "Save Directory"
                      : "Save Contact"
                    : "Save"}
                </div>
              )}
            </div>
          )}
          {!!props.whatsappInfo && (
            <div className="bhp-biz-card-whatsapp">
              <div
                className="bhp-biz-card-whatsapp-button"
                onClick={() => {
                  if (props?.recordUserInteraction) {
                    recordAction({
                      notes: `Click ${
                        props.buttonOverrideShare
                          ? props.buttonOverrideShare.name
                          : "Share"
                      }`,
                      action: userActionsTable.share,
                      pageId: props.id,
                      pageSection: "MAIN",
                      pageType: getPageType(props.isMarket, props.marketType),
                    });
                  }
                  if (props.buttonOverrideShare) {
                    props.buttonOverrideShare.exec();
                    return;
                  }
                  // let url =
                  // props.whatsappInfo.isMarket ||
                  // !props.whatsappInfo.marketDomain
                  // ? `https://${props.whatsappInfo.domainName}.vypzee.com`
                  // : `https://${props.whatsappInfo.marketDomain}.vypzee.com/business/${props.whatsappInfo.domainName}`;
                  // const message = `${
                  // props.whatsappInfo.isMarket ? "Market" : "Business"
                  // } ${props.whatsappInfo.name} is online. Visit at: ${url}`;
                  // const messageUser = `Visit and Save my Business Card. ${url}`;
                  // whatsappMessage(
                  // props.whatsappInfo.isMarket &&
                  // props.whatsappInfo.marketType === "USER"
                  // ? messageUser
                  // : message
                  // );
                  whatsappMessage(
                    getBhpShareMessage(
                      props.whatsappInfo.isMarket,
                      props.whatsappInfo.marketDomain,
                      props.whatsappInfo.domainName,
                      props.whatsappInfo.name,
                      props.whatsappInfo.marketType,
                      props.whatsappInfo.seoDetails
                    )
                  );
                }}
              >
                {props.buttonOverrideShare && (
                  <>{props.buttonOverrideShare.name}</>
                )}
                {!props.buttonOverrideShare && (
                  <>
                    <IonIcon icon={logoWhatsapp} />{" "}
                    <span style={{ paddingLeft: "5px" }}>Share Link</span>
                  </>
                )}
              </div>
            </div>
          )}
          {/* )} */}
        </div>
        {(!!props.shortDescription || props?.editMode) && (
          <div
            style={{
              position: "relative",
              top: "-8px",
              // padding: "0 15px",
              zIndex: "100",
            }}
          >
            <div
              style={{
                background:
                  "linear-gradient(to bottom right,var(--ion-color-light), #f0f0f0)",
                padding: "10px 25px",
                // border: "1px solid lightgray",
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                fontSize: "0.9rem",
                color: "var(--ion-color-bhp-footer)",
                border: "1px solid lightgray",
              }}
            >
              <div>
                {props?.shortDescription?.length > maxLength
                  ? `${props.shortDescription.slice(0, maxLength)}...`
                  : props?.shortDescription}
              </div>
              {(!!props.highlightButton || props.editMode) && (
                <div
                  style={{
                    marginTop: "10px",
                    marginBottom: "5px",
                    border: "var(--ion-color-light)",
                    background: props?.editMode
                      ? "var(--ion-color-tertiary)"
                      : "var(--ion-color-secondary)",
                    // : "linear-gradient(to right, #000000 0%, #1f1e0f 51%, #000000 100%)",
                    // : "linear-gradient(to right, #D31027 0%, #d12539  51%, #D31027  100%)",
                    color: "white",
                    display: "flex",
                    justifyContent: "center",
                    padding: "8px",
                    fontSize: "1rem",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                  }}
                  onClick={() => {
                    if (props?.editMode) {
                      // if (props?.subType?.startsWith("BNI-CHAPTER")) {
                      let { schoolId } = getSessionDetails();
                      if (schoolId == props?.id) {
                        history.push(
                          props?.bhpEditLinks?.shopProfile.replace(
                            "%storeId%",
                            `${props.id}`
                          )
                        );
                      } else {
                        history.push(
                          bhpEditLinks.shopProfile.replace(
                            "%storeId%",
                            `${props.id}`
                          )
                        );
                      }
                      // }
                      return;
                    }
                    if (props.recordUserInteraction) {
                      recordAction({
                        action: userActionsTable.bizCardCTAButton,
                        pageId: props.id,
                        pageSection: "MAIN",
                        pageType: getPageType(props.isMarket, props.marketType),
                        notes: props.highlightButton.name,
                      });
                    }
                    props.highlightButton.onClick();
                  }}
                >
                  <IonIcon
                    icon={props?.editMode ? pencil : props.highlightButton.icon}
                  />{" "}
                  <span style={{ paddingLeft: "10px" }}>
                    {props?.editMode ? "Details" : props.highlightButton.name}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BhpBizCard;
